import ResponsiveStyleSheet from "react-native-media-query";
import { theme } from "../../theme";
import { createResponsiveStyles } from "../../utils";
export const { styles, ids } = ResponsiveStyleSheet.create({
    wrapper: createResponsiveStyles({
        base: {
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "space-around",
        },
        small: {
            justifyContent: "center",
        },
    }),
    chevron: createResponsiveStyles({
        base: {
            padding: theme.spacing.small,
        },
        small: {
            paddingHorizontal: 0,
        },
    }),
    pageButton: {
        width: theme.spacing.large,
        height: theme.spacing.large,
        justifyContent: "center",
        alignItems: "center",
    },
    pageButtonSelected: {
        backgroundColor: theme.colors.light.base,
        borderRadius: theme.spacing.small,
    },
    ellipsis: {
        width: theme.spacing.large,
        textAlign: "center",
    },
});
//# sourceMappingURL=Pagination.styles.js.map